import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class MergeObjectsService {
    constructor() {}
    mergeJSON ( obj, source ) {
        for (let key in source )
        {
            if ( source[ key ] == null ) continue;
            obj[ key ] = this.replaceValue( obj[ key ], source[ key ] );
        }
        return obj;
    }

    replaceValue ( value, newValue ) {
        if ( Array.isArray( value ) && Array.isArray( newValue ) )
        {
            return newValue.map((val, i) => this.replaceValue( value[i], val ));
        } else if(this.isObject(value) && this.isObject(newValue))
        {
            return this.mergeJSON( value, newValue );
        }
        return newValue;
    }

    isObject ( obj ){
        return obj && obj.constructor === Object;
    }
}
